const ITEMS = [
  "100% COTTON HEAVYWEIGHT",
  "DTG PRINTED",
  "LOS ANGELES",
  "ΠΑΙΩΝΙΑ",
  "PREMIUM STREETWEAR",
  "MODERN × ANCIENT",
];

export const Marquee = ({ dark = false }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-5 select-none ${
        dark ? "bg-[#050505] text-white border-white/15" : "bg-white text-black border-black/10"
      }`}
    >
      <div className="flex w-max animate-marquee-slow">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={i} className="flex items-center whitespace-nowrap">
                <span className="font-serif italic text-xl md:text-2xl tracking-wide px-8">{item}</span>
                <span className={`text-[10px] ${dark ? "text-white/40" : "text-black/40"}`}>●</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
